<template>
  <div class="productPage">
    <h2>
      <!-- 热门产品 -->
      <div>
        <img v-lazy="hrefurl + '/public/home/title%26bg/homeProducts.png'" />
      </div>
    </h2>
    <div class="product">
      <div>
        <div class="scroll-content" ref="scrollContent">
          <div class="scroll-slide" v-for="(item, index) in arrList" :key="index" >
            <p @click="isDetails(item)">{{ item.proname_cn }}</p>
            <div class="bsImg1" @click="isDetails(item)">
              <img v-lazy="item.img_url" />
            </div>
            <div class="bsImg2" @click.stop="exhjump(item)">
              {{ item.corpname_cn }}
            </div>
          </div>
          <div class="scroll-slide" v-for="(item1, index) in arrList" :key="arrList.length + index" >
            <p @click="isDetails(item1)">{{ item1.proname_cn }}</p>
            <div class="bsImg1" @click="isDetails(item1)">
              <img v-lazy="item1.img_url" />
            </div>
            <div class="bsImg2" @click="exhjump(item1)">
              {{ item1.corpname_cn }}
            </div>
          </div>
        </div>
        <span class="scroll-button scroll-button-prev" @click="prev" >
          <img class="img1" v-lazy="hrefurl + '/public/exhibit/pageLeft.png'" />
        </span>
        <span class="scroll-button scroll-button-next" @click="next">
          <img class="img2" v-lazy="hrefurl + '/public/exhibit/pageLeft.png'" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { reqProListAd } from "../../../api";
export default {
  data() {
    return {
      arrList: [],
    };
  },
  mounted() {
    this.num = 0;
    this.init();
  },
  methods: {
    async init() {
      const response = await reqProListAd();
      if (response.code * 1 == 1) {
        this.arrList = response.resilt;
        this.width = this.arrList.length * 228 * 2;
        this.$refs.scrollContent.style.width = this.width + "px";
      } else {
        this.err(this, "请求失败，请稍后后重试。。。");
      }
    },

    prev() {
      if (this.num >= 0) {
        this.num = -this.width / 2;
        this.$refs.scrollContent.style.transform =
          "translateX(" + this.num + "px)";
        this.$refs.scrollContent.style.transition = "all 0s";
      }
      setTimeout(() => {
        this.betterScroll(228);
      }, 30);
    },

    next() {
      if (Math.abs(this.num) >= this.width - 1140) {
        this.num = 1140 - this.width / 2;
        this.$refs.scrollContent.style.transform =
          "translateX(" + this.num + "px)";
        this.$refs.scrollContent.style.transition = "all 0s";
      }
      setTimeout(() => {
        this.betterScroll(-228);
      }, 30);
    },

    betterScroll(amount) {
      this.num = amount + this.num;
      this.$refs.scrollContent.style.transform =
        "translateX(" + this.num + "px)";
      this.$refs.scrollContent.style.transition = "all .5s";
    },

    isDetails(item) { // 展品详情页跳转
      if (this.jump(this)) {
        this.$router.push("/exhibit/details/" + item.id + "/" + item.ocid);
      }
    },

    exhjump(item) { // 展商详情跳转
      if (this.jump(this)) {
        this.$router.push(
          "/exhibitor/details/" + item.corpid + "/" + item.ocid
        );
      }
    },
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
    }),
  },
};
</script>

<style  scoped>
.product {
  max-width: 1200px;
  height: 312px;
  position: relative;
  margin: 0 auto;
  background-color: #f1f1ef;
  padding: 10px 0;
  border: 1px solid #008baf;
}
h2 {
  text-align: center;
  padding: 70px 0 50px 0;
  font-size: 40px;
  color: #494c4d;
}
h2 > div {
  width: 300px;
  height: 80px;
  overflow: hidden;
  margin: 0 auto;
}
.product > div {
  width: calc(100% - 84px);
  height: 100%;
  margin: auto;
  overflow: hidden;
}
.scroll-content {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
}
.scroll-slide {
  /* position: relative; */
  width: 204px;
  height: 100%;
  margin-right: 24px;
  background-color: white;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
    0 2px 2px 0 rgba(40, 44, 53, 0.08);
}

/* 热门产品新增new标识 */
.scroll-slide-new::before{
  position: absolute;
  left: 0;
  top: 0;
  width: 34px;
  height: 34px;
  content: '';
  background: url(https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/new.png) no-repeat;
  background-size: 100%;
  z-index: 1;
}
.scroll-slide > p {
  font-size: 18px;
  color: #333333;
  padding: 10px 0;
  height: 76px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.scroll-slide > p:hover {
  color: #008baf;
}
.bsImg1 {
  width: 194px;
  height: 155px;
}


.bsImg2 {
  width: 194px;
  height: 55px;
  line-height: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
.bsImg2:hover {
  color: #008baf;
}
.scroll-slide img {
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
  width: 100%;
}
.scroll-slide .qyimg {
  border-top: 4px solid #ffffff;
  padding-top: 2px;
}
.scroll-slide img:hover {
  opacity: 0.5;
}
.scroll-button {
  position: absolute;
  width: 40px;
  height: 86px;
  top: 50%;
  transform: translateY(-50%);
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  font-size: 32px;
}
.scroll-button-prev {
  left: 0;
}
.scroll-button-next {
  right: 0;
}
.img1,
.img2 {
  cursor: pointer;
  user-select: none;
}
.img2 {
  transform: rotateY(180deg);
}
</style>
